var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEasy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-25.6 -25.6 563.20 563.20",
    xmlSpace: "preserve",
    width: "90px",
    height: "90px",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 11.776,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#9accc9;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M486.504,25.496H25.496C11.438,25.496,0,36.934,0,50.992v410.016c0,14.059,11.438,25.496,25.496,25.496 h461.008c14.058,0,25.496-11.437,25.496-25.496V50.992C512,36.934,500.562,25.496,486.504,25.496z M424.585,77.008 c15.806,0,28.618,12.813,28.618,28.618c0,15.806-12.812,28.618-28.618,28.618c-15.805,0-28.618-12.812-28.618-28.618 C395.968,89.821,408.78,77.008,424.585,77.008z M334.049,77.008c15.805,0,28.618,12.813,28.618,28.618 c0,15.806-12.813,28.618-28.618,28.618c-15.805,0-28.618-12.812-28.618-28.618C305.431,89.821,318.244,77.008,334.049,77.008z M243.512,77.008c15.806,0,28.618,12.813,28.618,28.618c0,15.806-12.812,28.618-28.618,28.618 c-15.805,0-28.618-12.812-28.618-28.618C214.894,89.821,227.707,77.008,243.512,77.008z M469.333,443.838H42.667V174.829h426.666 V443.838z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.415,
    y: 219.756,
    className: "st0",
    width: 226.341,
    height: 45.61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.415,
    y: 311.333,
    className: "st0",
    width: 337.17,
    height: 45.61
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasy);
export default __webpack_public_path__ + "static/media/easy.46a9069b6be0b2ac079bfcd97eb494b9.svg";
export { ForwardRef as ReactComponent };